import { globalVar, globalParam, customer } from '@/helpers/globals';
import { fieldRuleValue } from '@/helpers/tools';
/**
 * Helper mixin to easily access global variables
 * within components
 *
 * Defines component-wide methods:
 *
 * - globalVar(name)
 * - globalParam(name, default)
 * - customer()
 */
const globalsMixin = {
    methods: {
        globalVar(key: string) {
            return globalVar(key);
        },

        globalParam(key: string, defaultValue = null) {
            return globalParam(key, defaultValue);
        },

        fieldRuleValue<T>(ident: string, defaultValue: T): T {
            return fieldRuleValue(ident, defaultValue);
        },

        customer() {
            return customer();
        },
    },
};

export default globalsMixin;
